import InvestmentCalculator from "./components/InvestmentCalculator"; 
// or wherever your component is

function App() {
  return (
    <div>
      <InvestmentCalculator />
    </div>
  );
}

export default App;
